import getDocumentNameTranslated, {
  DocumentData,
} from './getDocumentNameTranslated';

interface GetDocumentLabelArgs {
  documentData: DocumentData;
  fileReference?: string;
}

const formatDocumentLabel = ({
  documentData,
  fileReference,
}: GetDocumentLabelArgs): string => {
  const documentName = getDocumentNameTranslated({ documentData });

  if (!fileReference) {
    return documentName;
  }
  const indexOfDocumentExtension = documentName?.lastIndexOf('.');

  if (indexOfDocumentExtension === -1) {
    return `${documentName} - ${fileReference}`;
  }

  const documentNameWithoutExtension = documentName?.substring(
    0,
    indexOfDocumentExtension,
  );
  const documentExtension =
    indexOfDocumentExtension !== undefined
      ? documentName?.substring(indexOfDocumentExtension)
      : '';

  return `${documentNameWithoutExtension} - ${fileReference}${documentExtension}`;
};

export default formatDocumentLabel;
